<template>
	<b-modal ref="modal" hide-footer size='xl'>
		<template v-slot:modal-title>
            {{ $t("monte.semence.add_commande") }}
        </template>

		<div class="row">
			<div class="col-6 from-group">
	    		<label class="col-form-label">{{ $t('monte.etalon') }} *</label>
	            <e-select
	                id="stallion"
	                track-by="horse_id"
	                label="horse_nom"
	                v-model="form.stallion"
	                :placeholder="$t('monte.selectionnez_etalon')"
	                :selectedLabel="$t('global.selected_label')"
	                :options="stallions"
	                :searchable="true"
	                :allow-empty="true"
	                :show-labels="false"
	                :loading="loading_stallion"
	            />
			</div>
			<div class="col-6 from-group">
	    		<label for="mare" class="col-form-label">{{ $t('monte.jument') }}</label>
				<input class="form-control" type="text" v-model="form.semenceexpedition_mare" id="mare">
			</div>
			<div v-if="show_destinataire_manuel" class="border col-12 mt-2">
				<div class="row">
					<div class="col-12">
						<h4 class="d-inline">{{ $t('monte.semence.destinataire_ca.coordonnees') }} :</h4>
			    		<a href="#" @click.prevent="showDestinataire" class="d-inline pt-2" style="float:right">{{ $t('monte.semence.back_destinataires') }}</a>
					</div>
					<div class="col-6 from-group">
			    		<label>{{ $t('monte.semence.destinataire_ca.rs') }} *</label>
						<b-input class="form-control" type="text" v-model="form.semenceexpedition_destinataire_manuel"></b-input>
					</div>
					<div class="col-6 form-group">
						<label>{{ $t('monte.semence.destinataire_ca.firstname') }} *</label>
						<b-input class="form-control" type="text" v-model="form.semenceexpedition_destinataire_manuel_firstname"></b-input>
					</div>
					<div class="col-6 form-group">
						<label>{{ $t('monte.semence.destinataire_ca.lastname') }} *</label>
						<b-input class="form-control" type="text" v-model="form.semenceexpedition_destinataire_manuel_lastname"></b-input>
					</div>
					<div class="col-6 form-group">
						<label>{{ $t('monte.semence.destinataire_ca.adress') }} *</label>
						<b-input class="form-control" type="text" v-model="form.semenceexpedition_destinataire_manuel_adress"></b-input>
					</div>
					<div class="col-6 form-group">
						<label>{{ $t('monte.semence.destinataire_ca.postalcode') }} *</label>
						<b-input class="form-control" type="text" v-model="form.semenceexpedition_destinataire_manuel_postalcode"></b-input>
					</div>
					<div class="col-6 form-group">
						<label>{{ $t('monte.semence.destinataire_ca.town') }} *</label>
						<b-input class="form-control" type="text" v-model="form.semenceexpedition_destinataire_manuel_town"></b-input>
					</div>
					<div class="col-6 form-group">
						<label>{{ $t('monte.semence.destinataire_ca.country') }} *</label>
						<CountryInput v-model="form.semenceexpedition_destinataire_manuel_country" />
					</div>
					<div class="col-6 form-group">
						<label>{{ $t('monte.semence.destinataire_ca.tel') }} *</label>
						<b-input class="form-control" type="text" v-model="form.semenceexpedition_destinataire_manuel_tel"></b-input>
					</div>
					<div class="col-6 form-group">
						<label>{{ $t('monte.semence.destinataire_ca.mail') }} *</label>
						<b-input class="form-control" type="text" v-model="form.semenceexpedition_destinataire_manuel_mail"></b-input>
					</div>
				</div>
			</div>

			<div v-else class="col-6 from-group">
	    		<label class="col-form-label">{{ $t('monte.semence.destinataire') }} *</label>
				<e-select
	                id="tiers"
	                track-by="tiers_id"
	                label="tiers_rs"
	                v-model="form.destinataire"
	                :placeholder="$t('monte.semence.selectionnez_destinataire')"
	                :selectedLabel="$t('global.selected_label')"
	                :options="destinataires"
	                :searchable="true"
	                :allow-empty="true"
	                :show-labels="false"
	                :loading="loading_tiers"
	            >
	            	<template slot="singleLabel" slot-scope="{ option }">
                        {{ option.tiers_rs }} 
                        <span v-if="option.tiers_address1 || option.tiers_postalcode || option.tiers_town">
                            - 
                            <span v-if="option.tiers_address1">{{ option.tiers_address1 | multiCapitalize }} </span>
                            <span v-if="option.tiers_address2">{{ option.tiers_address2 | multiCapitalize }} </span>
                            <span v-if="option.tiers_postalcode && option.tiers_postalcode > 0">, {{ option.tiers_postalcode }} </span>
                            <span v-if="option.tiers_town">{{ option.tiers_town | multiCapitalize }} </span>
                        </span>
                    </template>
                    
                    <template slot="option" slot-scope="{ option }">
                        {{ option.tiers_rs }} 
                        <span v-if="option.tiers_address1 || option.tiers_postalcode || option.tiers_town">
                        	- 
                            <span v-if="option.tiers_address1">{{ option.tiers_address1 | multiCapitalize }} </span>
                            <span v-if="option.tiers_address2">{{ option.tiers_address2 | multiCapitalize }} </span>
                            <span v-if="option.tiers_postalcode && option.tiers_postalcode > 0">, {{ option.tiers_postalcode }} </span>
                            <span v-if="option.tiers_town">{{ option.tiers_town | multiCapitalize }} </span>
                        </span>
                    </template>
                </e-select>
			</div>
			<div class="col-6 from-group">
	    		<label for="client" class="col-form-label">{{ $t('monte.semence.client') }}</label>
				<input class="form-control" type="text" v-model="form.semenceexpedition_client" id="client">
			</div>
			<div class="col-6 form-group">
				<label for="contract_num">{{ $t("monte.semence.contract_num") }}</label>
				<input class="form-control" type="text" v-model="form.semenceexpedition_contract_num" id="contract_num">
			</div>
			<div class="col-6 form-group">
				<label for="qte">{{ $t("monte.semence.qte") }} *</label>
				<b-form-checkbox class="d-inline" style="float:right" switch v-model="form.semenceexpedition_dose" id="dose">
					{{ $t("monte.semence.frais") }}
				</b-form-checkbox>
				<input :class="{'form-control': true, 'is-invalid' : form.semenceexpedition_qte < 0}" type="number" v-model="form.semenceexpedition_qte" id="qte">
			</div>
			<div class="col-6 form-group">
				<label for="date">{{ $t("monte.semence.date_expedition") }} *</label>
				<e-datepicker id="date" v-model="form.semenceexpedition_expedition_date" mode="date"></e-datepicker>
			</div>
			<div class="col-12 form-group">
				<label for="commentaire">{{ $t("monte.semence.commentaire") }}</label>
				<textarea id="commentaire" rows="5" class="form-control" v-model="form.semenceexpedition_commentaire_ca"></textarea>
			</div>
			<div class="col-12 text-center">
				<a class="btn btn-primary mt-3" href="#" @click.prevent="checkForm">{{ $t('action.ajouter') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']" /></a>
			</div>
		</div>
	</b-modal>
</template>

<script type="text/javascript">
	import Semence from "@/mixins/Semence.js"

	export default {
		name: 'AddCommande',
		mixins: [Semence],
		props: ['stallion_id'],
		data () {
			return {
				form: {
					stallion: null,
					semenceexpedition_mare: '',
					destinataire: null,
					semenceexpedition_destinataire_manuel: '',
					semenceexpedition_client: null,
					semenceexpedition_contract_num: null,
					semenceexpedition_dose: false,
					semenceexpedition_qte: 1,
					semenceexpedition_expedition_date: new Date(),
					semenceexpedition_commentaire_ca: '',
					semenceexpedition_destinataire_manuel_firstname: '',
					semenceexpedition_destinataire_manuel_lastname: '',
					semenceexpedition_destinataire_manuel_adress: '',
					semenceexpedition_destinataire_manuel_postalcode: '',
					semenceexpedition_destinataire_manuel_town: '',
					semenceexpedition_destinataire_manuel_country: '',
					semenceexpedition_destinataire_manuel_mail: '',
					semenceexpedition_destinataire_manuel_tel: ''
				},
				stallions: [],
				destinataires: [],
				processing: false,
				loading_stallion: false,
				loading_tiers: false
			}
		},

		methods: {
			async openModal() {
				this.$refs.modal.show()
				this.loading_stallion = true
				this.loading_tiers = true

				this.form.stallion = null
				this.form.semenceexpedition_mare = ''
				this.form.destinataire = null
				this.form.semenceexpedition_destinataire_manuel = ''
				this.form.semenceexpedition_client = null
				this.form.semenceexpedition_contract_num = null
				this.form.semenceexpedition_dose = false
				this.form.semenceexpedition_qte = 1
				this.form.semenceexpedition_expedition_date = new Date()
				this.form.semenceexpedition_commentaire_ca = ''
				this.form.semenceexpedition_destinataire_manuel_firstname = ''
				this.form.semenceexpedition_destinataire_manuel_lastname = ''
				this.form.semenceexpedition_destinataire_manuel_adress = ''
				this.form.semenceexpedition_destinataire_manuel_postalcode = ''
				this.form.semenceexpedition_destinataire_manuel_town = ''
				this.form.semenceexpedition_destinataire_manuel_country = ''
				this.form.semenceexpedition_destinataire_manuel_mail = ''
				this.form.semenceexpedition_destinataire_manuel_tel = ''

				this.getStallions().then(res => {
					this.loading_stallion = false
					this.stallions = res
					if(this.stallion_id) {
						this.form.stallion = this.stallions.find(h => h.horse_id == this.stallion_id)
					}
				})
				this.getTiersDestinataire().then(res => {
					this.loading_tiers = false
					this.destinataires = res
					this.destinataires.push({
						'tiers_id': 0,
						'tiers_rs': this.getTrad('monte.semence.add_destinataire')
					})
				})
			},

			async checkForm() {
				if(!this.form.stallion || (!this.form.destinataire && !this.form.semenceexpedition_destinataire_manuel) || this.processing || this.form.semenceexpedition_qte < 0) {
					return false
				}

				if(this.form.destinataire.tiers_id == 0 && (!this.form.semenceexpedition_destinataire_manuel || !this.form.semenceexpedition_destinataire_manuel_firstname || !this.form.semenceexpedition_destinataire_manuel_lastname || !this.form.semenceexpedition_destinataire_manuel_adress || !this.form.semenceexpedition_destinataire_manuel_postalcode || !this.form.semenceexpedition_destinataire_manuel_town || !this.form.semenceexpedition_destinataire_manuel_country || !this.form.semenceexpedition_destinataire_manuel_mail)) {
					return false
				}

				this.processing = true
				const params = {
					semenceexpedition_stallion: this.form.stallion.horse_id,
					semenceexpedition_mare: this.form.semenceexpedition_mare,
					semenceexpedition_destinataire: this.form.destinataire.tiers_id !== 0 ? this.form.destinataire.tiers_id : null,
					semenceexpedition_destinataire_manuel: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel : '',
					semenceexpedition_client: this.form.semenceexpedition_client,
					semenceexpedition_contract_num: this.form.semenceexpedition_contract_num,
					semenceexpedition_dose: this.form.semenceexpedition_dose,
					semenceexpedition_qte: this.form.semenceexpedition_qte,
					semenceexpedition_expedition_date: this.form.semenceexpedition_expedition_date.toDateInputValue(),
					semenceexpedition_commentaire_ca: this.form.semenceexpedition_commentaire_ca,
					semenceexpedition_destinataire_manuel_firstname: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel_firstname : '',
					semenceexpedition_destinataire_manuel_lastname: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel_lastname : '',
					semenceexpedition_destinataire_manuel_adress: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel_adress : '',
					semenceexpedition_destinataire_manuel_postalcode: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel_postalcode : '',
					semenceexpedition_destinataire_manuel_town: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel_town : '',
					semenceexpedition_destinataire_manuel_country: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel_country : '',
					semenceexpedition_destinataire_manuel_mail: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel_mail : '',
					semenceexpedition_destinataire_manuel_tel: this.form.destinataire.tiers_id == 0 ? this.form.semenceexpedition_destinataire_manuel_tel : ''
				}

				await this.addCommande(params)
				this.processing = false
				this.$refs.modal.hide()
				this.$emit('submit')
			},

			showDestinataire() {
				this.form.destinataire = null
			}
		},

		computed: {
			show_destinataire_manuel() {
				return this.form.destinataire && this.form.destinataire.tiers_id == 0
			}
		},

		components: {
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
			CountryInput : () => import('GroomyRoot/components/Inputs/CountryInput')
		}
	}

</script>